import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { RunTag } from "@/components/RunTag";

export default function Success() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/order/${orderId}`).then((r) => setOrder(r.data));
  }, [orderId]);

  if (!order) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <div className="flex h-[60vh] items-center justify-center font-mono-stamp text-xs text-[#a0a0a0]">
          LOCATING ORDER…
        </div>
      </div>
    );
  }

  return (
    <div data-testid="success-page" className="min-h-screen">
      <Navbar />
      <section className="mx-auto flex min-h-[calc(100vh-70px)] max-w-[1400px] flex-col items-center justify-center px-6 py-20 text-center md:px-10">
        <p className="font-mono-stamp text-xs text-[#a0a0a0]">
          ▸ ORDER STAMPED · CONFIRMED
        </p>
        <h1 className="font-display mt-6 text-6xl leading-[0.85] md:text-9xl">
          YOU GOT
          <br />
          <span className="text-outline">ONE.</span>
        </h1>

        <div className="mt-12 inline-flex">
          <RunTag
            designNo={order.design_no}
            runNumber={order.run_number}
            stamped
            className="scale-125 md:scale-150"
          />
        </div>

        <div className="mt-16 w-full max-w-md border-y border-[#333] py-6 text-left">
          <Row k="ITEM" v={order.item_name.toUpperCase()} />
          <Row k="DESIGN" v={order.design_no} />
          <Row k="RUN" v={order.run_number} />
          <Row k="TIER" v={order.tier_code} />
          <Row k="SIZE" v={order.size_code} />
          <Row k="TOTAL" v={`$${order.price}`} />
          <Row k="SHIPPING TO" v={order.full_name} />
          <Row k="CONFIRMATION" v={order.email} />
        </div>

        <p className="mt-8 max-w-lg font-mono-stamp text-xs leading-relaxed text-[#a0a0a0]">
          YOUR PIECE WILL BE HAND-STAMPED WITH THIS RUN NUMBER. NEVER REMADE.
          CHECK YOUR INBOX FOR TRACKING IN 48H.
        </p>

        <div className="mt-10 flex flex-col gap-4 md:flex-row">
          <Link
            to="/"
            data-testid="success-home"
            className="btn-brutal btn-brutal-solid"
          >
            BACK TO THE DROP →
          </Link>
          <Link
            to="/find-your-fit"
            data-testid="success-fyf"
            className="btn-brutal"
          >
            REFINE YOUR FIT
          </Link>
        </div>
      </section>
    </div>
  );
}

const Row = ({ k, v }) => (
  <div className="flex items-baseline justify-between border-b border-[#222] py-2 last:border-b-0">
    <span className="font-mono-stamp text-[10px] text-[#a0a0a0]">{k}</span>
    <span className="font-mono-stamp text-xs text-white">{v}</span>
  </div>
);
